import { render, staticRenderFns } from "./MultiplicationAndDivisionForm.vue?vue&type=template&id=4568f3f2&scoped=true&lang=pug&"
import script from "./MultiplicationAndDivisionForm.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAndDivisionForm.vue?vue&type=script&lang=js&"
import style0 from "./MultiplicationAndDivisionForm.vue?vue&type=style&index=0&id=4568f3f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568f3f2",
  null
  
)

export default component.exports